<template>
  <div class="container">
    <div class="nav-tab">
      <div style="display: flex">
        <img src="../../../../assets/images/arrow.png" class="ims" alt="" />
        <div>您的当前位置是：栏目导航</div>
      </div>
      <div
        class="hover-underline"
        style="display: flex; margin-right: 56px"
        @click="returnshow"
      >
        <div style="display: inline-block">
          <img src="../../../../assets/images/return.png" class="imgs" alt="" />
        </div>
        返回
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div class="nav-titie">
          栏目导航
          <div class="list-box">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="sidebar"
              :class="{ active: selectedItem === item }"
              @click="selectItem(item, index)"
            >
              {{ item }}
            </div>
            <img src="../../../../assets/images/nav-img.png" alt="" />
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right-img">
          <img src="../../../../assets/images/inf-news-long.png" alt="" />
          <div class="text">{{ selectedItem }}</div>
        </div>
        <div v-if="selectedItem" class="box">
          <div class="news">
            <ul class="custom-list">
              <li
                v-for="(item, index) in featureList"
                :key="index"
                @click="goInfo(item)"
              >
              <div class="li-content hover-underline wid color">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="page-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchFrom.pageNum"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="searchFrom.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
          <div v-if="selectedItem === '上级精神'" class="notification">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index" @click="goInfo(item)">
                <div class="li-content hover-underline wid">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="selectedItem === '机关文件'" class="dynamic">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index" @click="goInfo(item)">
                <div class="li-content hover-underline wid">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="selectedItem === '信息动态'" class="basic">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index" @click="goInfo(item)">
                <div class="li-content hover-underline wid">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="selectedItem === '活动风采'" class="express">
            <ul class="custom-list"> 
              <li v-for="(item, index) in featureList" :key="index" @click="goInfo(item)">
                <div class="li-content hover-underline wid">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="selectedItem === '典型风采'" class="express">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index" @click="goInfo(item)">
                <div class="li-content hover-underline wid">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="selectedItem === '党史资料'" class="focus">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index" @click="goInfo(item)">
                <div class="li-content hover-underline wid">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="selectedItem === '简报专刊'" class="survey">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index" @click="goInfo(item)">
                <div class="li-content hover-underline wid">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="selectedItem === '推荐阅读'" class="reference">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index" @click="goInfo(item)">
                <div class="li-content hover-underline wid">
                  <div>
                    {{ item.titleContent }}
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-info">
      <div class="bottom-box">
        <div>Copyright © 池州消防支队 allright reserved</div>
        <div>【后台管理】</div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { listspecial } from "@/api/SpecialWork";
import { dutyList } from "@/api/SpecialWork";
export default {
  name: "ImportantNews",
  props: ["columnType","type","winTitle","workId"],
  data() {
    return {
      list: [
        "工作动态",
        "专刊简报",
        "研讨交流",
        "工作指令",
        "学习园地",
      ],
      total: 0,
      selectedItem: "活动要闻",
      featureList: [], // 消防要闻
      searchFrom: {
        pageNum: 1,
        pageSize: 20,
        columnType: 0,
        workId: 4,
      },
    };
  },
  mounted() {
    console.log(this.columnType,this.type,this.winTitle,this.workId);
    this.dutyList(2)
  },
  methods: {
    async dutyList(type) {
      const query = {
        pageNum: 1,
        pageSize: 10,
        type:type
      }
      const  res = await dutyList(query)
      if(res.data.code == 200){
        this.list =  res.data.data.list.map(item=>{
          return item.post
        })
        query.type = 3
        const  res1 = await dutyList(query)
        if(res1.data.code == 200){
          this.list.push(...res1.data.data.list.map(item=>{
            return item.post
          })
          )
          this.selectedItem = this.list[this.type];
          this.searchFrom.columnType = this.columnType
          this.searchFrom.type = this.type
          this.searchFrom.status = 4
          this.searchFrom.workId = this.workId
          this.getlistAll();
        }
      }
    },
    handleSizeChange(val) {
      this.searchFrom.pageSize = val;
      this.getlistAll();
    },
    handleCurrentChange(val) {
      this.searchFrom.pageNum = val;
      this.getlistAll();
    },
    goInfo(item) {
        // 使用window.open方法在新窗口或选项卡中打开链接
        const ids = item.id
        const url = `/specialWork?ids=${encodeURIComponent(ids)}&param=${encodeURIComponent(this.workId)}`;
        window.open(url, "_blank");
    },
    getlistAll() {
      listspecial(this.searchFrom).then((res) => {
        this.featureList = res.data.data.list;
        this.total = res.data.data.total;
        
        this.featureList.forEach(item=>{
            if (item.titleContent.length>42) {
                item.titleContent =item.titleContent.slice(0,42) + "...";
            }
            if(item.releaseTime){
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
        })
      });
    },
    returnshow() {
      this.$emit("setCilck");
    },
    selectItem(item, index) {
      this.selectedItem = item;
      this.searchFrom.type = index;
      if(index >= 3){
        this.searchFrom.columnType = 1
      }else{
        this.searchFrom.columnType = 0
      }
      console.log(index);

      this.getlistAll();
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}

.container {
  width: 100%;
  background: #fff;
}

.nav-tab {
  width: 100%;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}

.content {
  width: 1120px;
  height: 841px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: start;
  align-items: flex-start;
  background-color: #fff;

  .custom-list {
    list-style-type: none;
    padding: 0 20px 0 12px;
  }
  .page-container{
    position: absolute;
    bottom: 0px;
  }
  .custom-list li {
    position: relative;
    padding-left: 18px;
    margin: 10px 0;
  }

  .custom-list li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    background-color: #c1c5cd;
    border-radius: 50%;
  }

  .li-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    span {
      display: inline-block;
      width: 40px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      background: #ffdfdf;
      border-radius: 4px;
      font-size: 10px;
      color: #cc0000;
      // margin-left: 10px;
    }
    .bgc {
      background-color: #f6f6f6;
    }
  }
  .custom-link {
    color: inherit;
    text-decoration: none;
  }
  .left {
    .nav-titie {
      position: relative;
      width: 180px;
      height: 701px;
      background: #0e67ab;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      padding: 12px;
      box-sizing: border-box;

      .list-box {
        position: absolute;
        top: 53px;
        left: 12px;
        width: 169px;
        background-color: #fff;

        .sidebar {
          width: 168px;
          height: 56px;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          line-height: 56px;
          padding-left: 20px;
          box-sizing: border-box;
        }

        .sidebar.active {
          background-color: #d4ac62;
          color: #fff;
        }

        img {
          width: 168px;
          height: 100px;
          margin-top: 16px;
        }
      }
    }
  }

  .right {
    // width: 820px;
    flex: 1;
    background: #ffffff;
    margin-left: 40px;

    .right-img {
      position: relative;

      img {
        width: 100%;
        height: 30px;
      }

      .text {
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        position: absolute;
        top: 5px;
        left: 16px;
      }
    }

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 633px;
      position: relative;
    }
      .news{
        width: 100%;
      }
    .detachment-leader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 40px 60px 0 60px;

      img {
        width: 180px;
        height: 180px;
        margin-bottom: 16px;
      }

      .name-detail {
        width: 180px;
        text-align: center;
      }
    }

    .detachment-leader > div:nth-child(2),
    .detachment-leader > div:nth-child(5) {
      margin-left: 90px;
      margin-right: 90px;
    }

    .intro {
      padding-top: 40px;
      background-color: #fff;

      #text {
        display: inline-block;
      }
    }

    .location {
      padding-top: 40px;
    }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
</style>
